import React from "react";
import "../templeTrustees/templetrustees.css";
import { Link } from "react-router-dom";
// import { Button, Table } from "react-bootstrap";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Button, Container, Grid } from "@mui/material";
import { IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import usePujaSamagri from "./customHook";

function PoojaSamagriList() {
  const { pujaSamagri, loading, error, handleDownload } = usePujaSamagri();
  const [copied, setCopied] = React.useState(false);

  const handleCopy = async (url) => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error("Failed to copy URL: ", error);
    }
  };

  return (
    <>
      <Container maxWidth={'xl'} className="page-header py-4 breadcrumb-bg">
        <h1 className="text-center display-6 breadcrumb-h1">
          Pooja Samagri List
        </h1>
        <ul className="breadcrumb justify-content-center mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/">Services</Link>
          </li>
          <li className="breadcrumb-item active">Pooja Samagri List</li>
        </ul>
      </Container>

      <Container className="py-5">
        <Grid className="text-center mb-5">
          <h6 className="section-title text-center text-primary text-uppercase title-tl">
            Pooja
          </h6>
          <h1 className="mb-3">
            <span className="text-secundary">Samagri List</span>
          </h1>
        </Grid>

        <TableContainer>
          <Table
            sx={{ minWidth: 650 }}
            aria-label="simple table"
            className="table-bdr"
          >
            <TableHead>
              <TableRow>
                <TableCell className="tbl-td" style={{ fontWeight: 600 }}>
                  Name of the Service
                </TableCell>
                <TableCell className="tbl-td" style={{ fontWeight: 600 }}>
                  Category of Service
                </TableCell>
                <TableCell className="tbl-td" style={{ fontWeight: 600 }}>
                  Pooja Samagri List
                </TableCell>
                <TableCell className="tbl-td" style={{ fontWeight: 600 }}>
                  {" "}
                  PDF
                </TableCell>
                <TableCell className="tbl-td" style={{ fontWeight: 600 }}>
                  URL
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pujaSamagri?.map((row) => (
                <TableRow key={row.id}>
                  <TableCell component="th" scope="row" className="tbl-td">
                    {row?.servicename}
                  </TableCell>
                  <TableCell className="tbl-td">{row?.category}</TableCell>

                  <TableCell className="tbl-td">{row?.description}</TableCell>
                  <TableCell className="tbl-td">
                    <Button
                      onClick={() => {
                        handleDownload(row?.file);
                      }}
                    >
                      Download PFD
                    </Button>
                  </TableCell>
                  <TableCell className="tbl-td">
                    <Tooltip title={copied ? "Copied!" : "Copy URL"} arrow>
                      <IconButton
                        color="primary"
                        onClick={() => {
                          handleCopy(row.file);
                        }}
                      >
                        <ContentCopyIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </>
  );
}

export default PoojaSamagriList;
